import { Component, inject } from '@angular/core';
import { ComponentsModule, DialogService, TabAppearance, TabItem } from '@mastechnicaegroup/carelinelive-ui';
import { HeaderComponent } from '@shared/layout/header/header.component';
import { ReportsActiveReportsTabComponent } from "./tabs/active-reports/reports-active-reports-tab.component";
import { ReportsHistoryTabComponent } from "./tabs/history/reports-history-tab.component";
import { RunReportDialogComponent } from '../../dialogs/run/run-report-dialog.component';

@Component({
    selector: 'app-reports-index-page',
    imports: [
        ComponentsModule,
        HeaderComponent,
        ReportsActiveReportsTabComponent,
        ReportsHistoryTabComponent
    ],
    templateUrl: './reports-index-page.component.html',
    standalone: true,
    styleUrl: './reports-index-page.component.scss'
})
export class ReportsIndexPageComponent {
    protected currentTabId = '0';
    protected isActiveReportsTabOpen = true;
    protected isHistoryTabOpen = false;
    private readonly _dialog = inject(DialogService);

    tabAppearance: TabAppearance = 'contained';
    protected readonly tabItems: TabItem[] = [
        {
            disabled: false,
            id: '0',
            title: 'Active'
        },
    ];

    openActiveReportsTab() {
        this.closeAllTabs();
        this.isActiveReportsTabOpen = true;
    }

    openHistoryTab() {
        this.closeAllTabs();
        this.isHistoryTabOpen = true;
    }

    closeAllTabs() {
        this.isActiveReportsTabOpen = false;
        this.isHistoryTabOpen = false;
    }

    public currentTabIdChange(tabId: string) {
        this.currentTabId = tabId;
        switch (tabId) {
            case '0':
                this.openActiveReportsTab();
                break;
            case '1':
                this.openHistoryTab();
                break;
        }
    }

    runReport() {
        return RunReportDialogComponent.show(this._dialog);
    }

}
